import { render, staticRenderFns } from "./VoiceRecordControl.vue?vue&type=template&id=d02413e0&scoped=true"
import script from "./VoiceRecordControl.vue?vue&type=script&lang=js"
export * from "./VoiceRecordControl.vue?vue&type=script&lang=js"
import style0 from "./VoiceRecordControl.vue?vue&type=style&index=0&id=d02413e0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d02413e0",
  null
  
)

export default component.exports